import { ChevronLeft16, Close16 } from '@carbon/icons-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Meeting } from 'api/meeting/types';
import { Button } from 'components/atoms/button';
import { Caption01 } from 'components/styles';
import { AiFillGradientBackground } from 'components/styles/components/ai-fill';
import { MeetingSelector } from './meetings-selector-v2/meeting-selector';
import { AiFillMeta } from './types';

const SelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderWrapper = styled.div`
  padding: var(--spacing-03);
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${AiFillGradientBackground};
`;

const Primary = styled.div``;

const Secondary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-grow: 1;
  margin-left: var(--spacing-03);
`;

const Tertiary = styled.div``;

const Title = styled.div`
  font-weight: var(--font-weight-bold);
`;

const Description = styled.div`
  ${Caption01};
`;

export const MeetingsForAiFillSelector = ({
  onBack,
  onClose,
  onGenerate,
  selectedAppName,
  aiFillMeta,
}: {
  onBack: (e) => void;
  onClose: (e) => void;
  onGenerate: (meetings: Meeting[]) => void;
  selectedAppName: string;
  aiFillMeta?: AiFillMeta;
}) => {
  return (
    <SelectorWrapper className="ai-fill-meeting-selector-popup">
      <HeaderWrapper>
        <Primary>
          <Button
            size="small"
            type="text"
            onClick={onBack}
            icon={<ChevronLeft16 />}
          />
        </Primary>

        <Secondary>
          <Title>
            <FormattedMessage id="ai_fill.meetings.select.drawer.connected.title" />
          </Title>
          <Description>{selectedAppName}</Description>
        </Secondary>
        <Tertiary>
          <Button
            size="small"
            type="text"
            onClick={onClose}
            icon={<Close16 />}
          />
        </Tertiary>
      </HeaderWrapper>
      <MeetingSelector onGenerate={onGenerate} meta={aiFillMeta} />
    </SelectorWrapper>
  );
};
